
import { defineComponent, nextTick, onBeforeUnmount, onMounted } from "vue";
import Room from "@/components/room/room.vue";
import store from "@/store";
import Agora from "@/assets/common/Agora";

export default defineComponent({
  name: "OneToOne",
  components: {
    Room
  },
  setup() {
    const agora: Agora | null = window.agora;

    onMounted(() => {
      nextTick(() => {
        if (agora) {
          // 直接使用 DOM API 规避无服务状态下 ctx 不识别的问题
          // const local = ctx.$refs["local"];
          // const container = ctx.$refs["ideo-wrapper"];
          const local = document.getElementById("local")!;
          const container = document.getElementById("videoContainer")!;
          agora.joinChannel(local, container);
        }
      });
    });

    onBeforeUnmount(() => {
      agora?.dispose();
      window.agora = null;
    });

    return {
      name: store.state.channel
    };
  }
});
